// extracted by mini-css-extract-plugin
export default {"container":"CircularProcess_container__QhJiR","verticalLayout":"CircularProcess_verticalLayout__fvDMo"};